<template>
    <div>
        <Sticky :offset-top="40">
            <Search placeholder="请输入勘查项名称模糊匹配" v-model="searchInput" @search="onRefresh"/>
        </Sticky>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <TaskItemInfo v-for="item in taskItems" :key="item.id" :taskItem="item" @onUpdate="onUpdate" @onRefresh="onRefresh"/>
            </List>
            <Button type="info" block class="fixed-bottom-button"
                    @click="updateTaskItem">新增勘查项
            </Button>
        </PullRefresh>
        <TaskItemPopup :show="show" type="taskPopup" @panel="switchPanel" @onRefresh="onRefresh"/>
        <TaskItemDealPopup :show="taskItemDealPanel" type="taskItemDealPopup" @panel="switchPanel"
                           :key="selected.id" :taskItemDeal="selected" @onRefresh="onRefresh"/>
    </div>
</template>

<script>
    import {Button, List, PullRefresh, Search, Sticky} from "vant"
    import TaskItemInfo from "./TaskItemInfo"
    import TaskItemPopup from "../components/TaskItemPopup"
    import TaskItemDealPopup from "../components/TaskItemDealPopup"

    export default {
        components: {
            TaskItemPopup,
            List,
            TaskItemDealPopup,
            Search,
            PullRefresh,
            Sticky,
            TaskItemInfo,
            Button
        },
        props: {},
        data() {
            return {
                taskId: this.$route.params.id,
                taskItems: [],
                searchInput: null,
                isReFresh: false,
                loading: false,
                show: false,
                name: null,
                remark: null,
                finished: false,
                selected:{},
                taskItemDealPanel:false
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            onUpdate(selected){
                this.selected=selected
              this.taskItemDealPanel=true
            },
            switchPanel(type) {
                switch (type) {
                    case "taskPopup":
                        this.show = !this.show;
                        break;
                    case "taskItemDealPopup":
                        this.taskItemDealPanel = !this.taskItemDealPanel;
                        break;
                    default:
                        break;
                }
            },
            updateTaskItem() {
                this.show = true;
            },
            onRefresh() {
                this.isReFresh = true;
                this.taskItems = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.prospect.taskItem.list({
                    name: this.searchInput,
                    taskId: this.taskId,
                    size: 20,
                    // page:this.taskItems.length / 20 + 1
                })
                    .then(res => {
                        if (res) {
                            this.taskItems.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            if (this.taskItems.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            }
        },
        watch: {}
    }
</script>

<style scoped>
    .fixed-bottom-button {
        position: fixed;
        bottom: 8px;
        width: calc(100% - 16px);
    }

</style>